// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rapidash: PokeData = {
  "id": 78,
  "name": "rapidash",
  "height": 17,
  "weight": 950,
  "base_experience": 175,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "stomp",
    "double-kick",
    "fury-attack",
    "horn-drill",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "growl",
    "ember",
    "fire-spin",
    "hypnosis",
    "agility",
    "quick-attack",
    "fire-blast",
    "flame-wheel",
    "megahorn",
    "bounce",
    "flare-blitz",
    "poison-jab",
    "double-hit",
    "flame-charge",
    "inferno",
    "smart-strike"
  ],
  "moves": [
    "double-kick",
    "tackle",
    "growl",
    "ember",
    "fire-spin",
    "quick-attack",
    "flare-blitz",
    "poison-jab",
    "smart-strike",
    "morning-sun",
    "sunny-day",
    "flamethrower",
    "blaze-kick"
  ],
  "evolution_chain": {
    "id": 32,
    "item": null,
    "species": [
      {
        "name": "ponyta",
        "order": 83,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "rapidash",
        "order": 84,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 77,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 102,
    "speed": 153,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
